import { analyticsReducer, analyticsState } from './crmReportsReducer/analyticsReducer.js';
import { ecommerceReducer, ecommerceState } from './crmReportsReducer/ecommerceReducer.js';
import { leadsReducer, leadsState } from './crmReportsReducer/leadsReducer.js';
import { paidAdsReducer, paidAdsState } from './crmReportsReducer/paidAdsReducer.js';
import { rankingsReducer, rankingsState } from './crmReportsReducer/rankingsReducer.js';
import { reviewsReducer, reviewsState } from './crmReportsReducer/reviewsReducer.js';

import { createReducer } from 'lib/utilities.js';

const initialState = {
  index: {
    data: [],
  },
  show: {
    data: {
      id: null,
      amazon_integration: null,
      ga_property_id: null,
      se_site_id: null,
      adwords_id: null,
      shopify_url: '',
      shopify_access_token: null,
      fb_ads_id: null,
      client: {
        archived: 0,
        categories_id: null,
        category: { id: null, name: null },
        contacts: [],
        id: null,
        manager: {
          client_id: null,
          email: null,
          first_name: null,
          id: null,
          job: null,
          last_name: null,
          profile_image: null,
          role_id: null,
        },

        manager_id: null,
        name: null,
        primary_site_id: null,
        profile_image: null,
        sites: [],
        supportbee_label: null,
      },
    },
    permissions: { isPublic: false },
    ...analyticsState,
    ...rankingsState,
    ...leadsState,
    ...paidAdsState,
    ...ecommerceState,
    ...reviewsState,
  },
};

export default createReducer(initialState, {
  ...analyticsReducer,
  ...rankingsReducer,
  ...leadsReducer,
  ...paidAdsReducer,
  ...ecommerceReducer,
  ...reviewsReducer,

  UPDATING_ADWORDS_ID_WITH_MCC_SUB_ACCOUNT_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      data: {
        ...state.show.data,
        adwords_id: payload,
      },
    },
  }),
  SET_PERMISSION: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      permissions: { isPublic: payload },
    },
  }),
  FETCHING_SITES_SUCCESS: (state, payload) => ({
    ...state,
    index: {
      ...state.index,
      data: payload,
    },
  }),
  FETCHING_SITE_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      data: payload,
    },
  }),
  UPDATING_SITE_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      data: {
        ...state.show.data,
        ...payload,
      },
    },
  }),
  UPDATE_AMAZON_INTEGRATION_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      data: {
        ...state.show.data,
        amazon_integration: payload,
      },
    },
  }),
  SAVE_TWITTER_HANDLE_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      data: {
        ...state.show.data,
        twitter_username: payload,
      },
    },
  }),
  FETCHING_SOCIAL_INSTAGRAM_BUSINESS_ID_SUCCESS: (state, payload) => ({
    ...state,
    show: {
      ...state.show,
      data: {
        ...state.show.data,
        instagram_business_id: payload,
      },
    },
  }),
});
